function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAthleteiqLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 680 240",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 118,
    r: 88,
    fill: "#4F46E5",
    style: {
      fill: "rgb(79, 70, 229)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: 118,
    x2: 192,
    y2: 118,
    stroke: "rgba(255,255,255,0.12)",
    strokeWidth: 1,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgba(255, 255, 255, 0.12)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "32,118 60,118 80,52 100,168 122,72 144,118 192,118",
    fill: "none",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 52,
    r: 6,
    fill: "#10b981",
    style: {
      fill: "rgb(16, 185, 129)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122,
    cy: 72,
    r: 6,
    fill: "#10b981",
    style: {
      fill: "rgb(16, 185, 129)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 118,
    r: 4.5,
    fill: "rgba(255,255,255,0.5)",
    style: {
      fill: "rgba(255, 255, 255, 0.5)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 226,
    y: 135,
    fontFamily: "var(--font-sans)",
    fontSize: 62,
    fontWeight: 700,
    letterSpacing: -1,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 62,
      fontWeight: 700,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "rgb(249, 250, 251)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 62,
      fontWeight: 700,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Athlete"), /*#__PURE__*/React.createElement("tspan", {
    style: {
      fill: "rgb(79, 70, 229)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 62,
      fontWeight: 700,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "IQ")), /*#__PURE__*/React.createElement("text", {
    x: 229,
    y: 165,
    fontFamily: "var(--font-sans)",
    fontSize: 12,
    fontWeight: 400,
    letterSpacing: 3.5,
    style: {
      fill: "rgb(107, 114, 128)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 12,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "AI PERFORMANCE MANAGEMENT"), /*#__PURE__*/React.createElement("line", {
    x1: 229,
    y1: 175,
    x2: 620,
    y2: 175,
    stroke: "#e5e7eb",
    strokeWidth: 0.5,
    opacity: 0.4,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(229, 231, 235)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "0.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.4,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 229,
    y: 196,
    fontFamily: "var(--font-sans)",
    fontSize: 11,
    fontWeight: 400,
    letterSpacing: 1,
    opacity: 0.7,
    style: {
      fill: "rgb(107, 114, 128)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 11,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Powered by AthleteIQ \xB7 athleteiq.in"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAthleteiqLogo);
export default __webpack_public_path__ + "static/media/athleteiq_logo.9aaa684f051a2b90a561431c61f948be.svg";
export { ForwardRef as ReactComponent };